<template>
  <v-dialog
    :value="show"
    max-width="500px"
    transition="dialog-transition"
    @input="closeModal">
    <v-card v-if="show">
      <v-card-title class="headline k-orange-linear">
        <div>
          <h3 class="headline mb-0">Cargar archivo</h3>
        </div>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12>
            <div class="dropbox">
              <div class="content justify-center align-center">
                <span v-if="!file.fileName">Elija el archivo a cargar....</span>
                <div v-else class="d-flex align-center">
                  <span class="fa-stack fa-2x">
                    <i class="far fa-file fa-stack-2x"></i>
                    <span class="fas fa-stack-1x extention">{{ file.fileExtention }}</span>
                  </span>
                  <span>{{ file.fileName }}</span>
                </div>
              </div>
              <input type="file" @change="fileChanged">  
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-layout row wrap justify-end>
          <v-btn flat color="black" @click="closeModal()">Cancelar</v-btn>
          <v-btn class="k-orange-linear-text" flat :disabled="urlStatus" @click="uploadFile">Cargar</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import axios from 'axios';

  export default {
    props: {
      show: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        urlStatus: false,
        file: {
          fileData: '',
          fileName: '',
          fileMime: '',
          fileExtention: '',
        },
        data: {},
      };
    },
    methods: {
      fileChanged(e) {
        const files = e.target.files || e.dataTransfer.files;
        this.file.fileName = files[0].name;
        this.file.fileMime = files[0].type;
        this.file.fileExtention = files[0].name.split('.').pop();
        if (!files.length) return;

        this.createFile(files[0]).then((data) => {
          this.file.fileData = data;
        });

        this.axios.post('/notification_schedules/upload/url', {
          ext: this.file.fileExtention,
          name: this.file.fileName,
          mime: this.file.fileMime,
        }).then(({ data }) => {
          this.data = JSON.parse(data);
        }).catch(() => {
          this.file = {
            fileData: '',
            fileName: '',
            fileMime: '',
            fileExtention: '',
          };
        });
      },
      async createFile(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => {
            resolve(reader.result);
          };

          reader.onerror = reject;
          reader.readAsArrayBuffer(file);
        });
      },
      uploadFile() {
        const blobData = new Blob([this.file.fileData], { type: this.file.fileMime });
        axios({
          method: 'put',
          url: this.data.uploadURL,
          body: blobData,
          headers: {
            'Content-Type': this.file.fileMime,
          },
        }).then(() => {
          // console.log(response);
        }).catch(() => {
          // console.log(error);
        });
      },
      removeImage() {
        this.image = '';
      },
      closeModal() {
        this.file = {
          fileName: '',
          fileMime: '',
          fileExtention: '',
        };
        this.$emit('close');
      },
    },
    watch: {
      data(newVal) {
        if (!newVal) {
          this.urlStatus = false;
        }
      },
    },
  };
</script>
<style>
.dropbox {
  width: 100%;
  height: 200px;
  cursor: pointer;
  border: 3px dashed #f57a64;
  position: relative;
  border-radius: 4px;
}
.dropbox > .content {
  width: 100%;
  height: 100%;

}
.dropbox > .content > .d-flex {
  flex-direction: column;
}
.dropbox > input[type = file] {
  top: 0;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  position: absolute;
}
.extention {
  font-size: .5em;
}
</style>



// WEBPACK FOOTER //
// src/components/notification_schedule/UploadFileDialog.vue